import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import first from 'lodash.first';
import get from 'lodash.get';
import { uniqueIdForComponent } from '../util';
import Button from './Button';
import IconSet from './IconSet';
var propTypes = {
  /**
   additional styling for the Tabs
  */
  className: PropTypes.string,

  /**
   Tab elements
  */
  children: PropTypes.node.isRequired,

  /**
   support horizontal scrolling of tabs
  */
  scrollable: PropTypes.bool,

  /** id of the selected tab, defaults to the first tab id */
  current: PropTypes.string,

  /** ariaLabel for the navigation element */
  ariaLabel: PropTypes.node,

  /** ariaLabel for the scroll left button on scrollable tabs */
  ariaLabelScrollLeftButton: PropTypes.node,

  /** ariaLabel for the scroll right button on scrollable tabs */
  ariaLabelScrollRightButton: PropTypes.node,

  /** called with selected tab id the whenever the current tab is changed by clicking on a different tab element, or when programmatically updating the `current` prop  */
  onTabSelected: PropTypes.func,

  /** inverse tabs, used on a dark background */
  inverse: PropTypes.bool
};
var defaultProps = {
  className: undefined,
  scrollable: false,
  ariaLabel: undefined,
  current: undefined,
  onTabSelected: undefined,
  inverse: false,
  ariaLabelScrollLeftButton: 'Scroll left',
  ariaLabelScrollRightButton: 'Scroll right'
};

var Tabs = /*#__PURE__*/function (_Component) {
  _inherits(Tabs, _Component);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tabs).call(this, props));
    _this.defaultSelectedId = _this.defaultSelectedId.bind(_assertThisInitialized(_this));
    var uuid = "tabs-".concat(uniqueIdForComponent(_assertThisInitialized(_this)));
    _this.state = {
      uuid: uuid,
      selectedId: _this.defaultSelectedId(uuid)
    };
    return _this;
  }

  _createClass(Tabs, [{
    key: "defaultSelectedId",
    value: function defaultSelectedId(fallback) {
      if (this.props.current) {
        return this.props.current;
      }

      return get(first(React.Children.toArray(this.props.children)), 'props.id') || "".concat(fallback, "-tab-0");
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      var className = _ref.className,
          children = _ref.children,
          scrollable = _ref.scrollable,
          ariaLabel = _ref.ariaLabel,
          ariaLabelScrollLeftButton = _ref.ariaLabelScrollLeftButton,
          ariaLabelScrollRightButton = _ref.ariaLabelScrollRightButton,
          current = _ref.current,
          onTabSelected = _ref.onTabSelected,
          inverse = _ref.inverse,
          otherProps = _objectWithoutProperties(_ref, ["className", "children", "scrollable", "ariaLabel", "ariaLabelScrollLeftButton", "ariaLabelScrollRightButton", "current", "onTabSelected", "inverse"]);

      var uuid = this.state.uuid;
      var styleClass = classnames('wds-c-tabs', className, {
        'wds-c-tabs--scrollable': scrollable,
        'wds-c-tabs--inverse': inverse
      }); // extract the content out of the Tab children

      var tabPanels = React.Children.map(children, function (child, index) {
        return child && child.props.children && React.createElement("div", {
          role: "tabpanel",
          "aria-labelledby": child.props.id || "".concat(uuid, "-tab-").concat(index),
          id: "".concat(uuid, "-panel-").concat(index),
          "aria-hidden": (child.props.id || "".concat(uuid, "-tab-").concat(index)) !== _this2.state.selectedId
        }, child.props.children);
      });
      var hasPanels = tabPanels && tabPanels.length > 0;
      var tabs = React.Children.map(children, function (child, index) {
        return child && React.cloneElement(child, {
          id: child.props.id || "".concat(uuid, "-tab-").concat(index),
          selected: (child.props.id || "".concat(uuid, "-tab-").concat(index)) === _this2.state.selectedId,
          'aria-controls': hasPanels ? "".concat(uuid, "-panel-").concat(index) : undefined,
          'data-target': hasPanels ? "".concat(uuid, "-panel-").concat(index) : undefined,
          'props.children': undefined
        });
      });
      return [React.createElement("div", _extends({
        key: "tab-list",
        className: styleClass,
        role: "tablist"
      }, otherProps), React.createElement("div", {
        className: classnames({
          'wds-c-tabs__scrollable-container': scrollable
        })
      }, React.createElement("nav", _extends({
        className: "wds-c-tabs__list",
        "data-overflowing": "none"
      }, ariaLabel && {
        'aria-label': ariaLabel
      }, {
        onClick: function onClick(e) {
          var selectedTabId = e.target.id || e.target.parentNode.id;

          if (selectedTabId !== _this2.state.selectedId && selectedTabId) {
            _this2.setState({
              selectedId: selectedTabId
            });

            if (onTabSelected) {
              onTabSelected(selectedTabId);
            }
          }
        }
      }), tabs), scrollable && React.createElement(React.Fragment, null, React.createElement("div", {
        className: "wds-c-tabs__advancer wds-c-tabs__advancer--left"
      }, React.createElement(Button, {
        category: "icon",
        className: "wds-c-tabs__advancer-button",
        "data-scroll-direction": "left",
        tabIndex: "-1",
        "aria-label": ariaLabelScrollLeftButton,
        "aria-hidden": "true",
        icon: React.createElement(IconSet, {
          directional: true,
          decorative: true,
          name: "chevron-left"
        })
      })), React.createElement("div", {
        className: "wds-c-tabs__advancer wds-c-tabs__advancer--right"
      }, React.createElement(Button, {
        category: "icon",
        className: "wds-c-tabs__advancer-button",
        "data-scroll-direction": "right",
        tabIndex: "-1",
        "aria-label": ariaLabelScrollRightButton,
        "aria-hidden": "true",
        icon: React.createElement(IconSet, {
          directional: true,
          decorative: true,
          name: "chevron-right"
        })
      }))))), tabPanels];
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.current && nextProps.current !== prevState.selectedId) {
        if (nextProps.onTabSelected) {
          nextProps.onTabSelected(nextProps.current);
        }

        return {
          selectedId: nextProps.current
        };
      } // no change to state


      return null;
    }
  }]);

  return Tabs;
}(Component);

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;
Tabs.displayName = 'Tabs';
export default Tabs;